// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { deviceId } from './Device';
import { z } from 'zod';
export const deviceConfigSync = z.object({
    device_id: deviceId,
    desired_hash: z.string().nullable(),
    reported_config_hash: z.string().nullable(),
    applied_hash: z.string().nullable(),
    pending: z.boolean(),
    last_push_at: z.date().nullable(),
    last_synced_at: z.date().nullable(),
    created_at: z.date(),
    updated_at: z.date(),
});
export const deviceConfigSyncInitializer = z.object({
    device_id: deviceId,
    desired_hash: z.string().optional().nullable(),
    reported_config_hash: z.string().optional().nullable(),
    applied_hash: z.string().optional().nullable(),
    pending: z.boolean().optional(),
    last_push_at: z.date().optional().nullable(),
    last_synced_at: z.date().optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
});
export const deviceConfigSyncMutator = z.object({
    device_id: deviceId.optional(),
    desired_hash: z.string().optional().nullable(),
    reported_config_hash: z.string().optional().nullable(),
    applied_hash: z.string().optional().nullable(),
    pending: z.boolean().optional(),
    last_push_at: z.date().optional().nullable(),
    last_synced_at: z.date().optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
});
//# sourceMappingURL=DeviceConfigSync.js.map